import { render, staticRenderFns } from "./OrganisationSubscriptionAdd.vue?vue&type=template&id=1735110a&"
import script from "./OrganisationSubscriptionAdd.vue?vue&type=script&lang=ts&"
export * from "./OrganisationSubscriptionAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1735110a')) {
      api.createRecord('1735110a', component.options)
    } else {
      api.reload('1735110a', component.options)
    }
    module.hot.accept("./OrganisationSubscriptionAdd.vue?vue&type=template&id=1735110a&", function () {
      api.rerender('1735110a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/organisations/OrganisationSubscriptionAdd.vue"
export default component.exports